import { useEffect, useRef } from 'react';
import { useToggle } from '~/hooks';

interface IUseDateRemovalProps {
  onRemoveDate(index: number): void;
}

export const useDateRemoval = ({ onRemoveDate }: IUseDateRemovalProps) => {
  const [isShowConfirmation, controls] = useToggle(false);

  const selectedValueRef = useRef<{ index: number; value: Date } | undefined>(undefined);

  const handleRemoveDate = (value: Date, index: number) => {
    selectedValueRef.current = { index, value };
    controls.setOn();
  };

  const handleConfirmRemoval = () => {
    controls.setOff();
    if (selectedValueRef.current) {
      onRemoveDate(selectedValueRef.current.index);
      selectedValueRef.current = undefined;
    }
  };

  const handleDeclineRemoval = () => {
    selectedValueRef.current = undefined;
    controls.setOff();
  };

  useEffect(() => {
    return () => {
      selectedValueRef.current = undefined;
    };
  }, []);

  return {
    context: selectedValueRef.current,
    isShowConfirmation,
    ref: selectedValueRef,
    handleConfirmRemoval,
    handleDeclineRemoval,
    handleRemoveDate,
  };
};
